import { shopperHead } from "@commerce/shopper/meta";
import { OrderTracking } from "@commerce/shopper/orders/OrderTracking";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { buildCsp } from "~/server/csp";
import { getShopperPageFn } from "~/server/shopper";

/**
 * Order tracking (B3 task 10): where an order Hephon placed is, by the signed token in every
 * order message. Public; the token is in the path, so no Referer carries it away.
 */
export const Route = createFileRoute("/c/$orgSlug_/orders/$token")({
	staticData: { retailerPage: true },
	loader: async ({ params }) => {
		const page = await getShopperPageFn({
			data: { orgSlug: params.orgSlug },
		});
		if (!page) {
			throw notFound();
		}
		return page;
	},
	head: ({ loaderData, params }) =>
		shopperHead(loaderData, {
			title: loaderData
				? `Your order · ${loaderData.retailerName}`
				: "Your order",
			description: "Where your order is.",
			path: `/c/${params.orgSlug}/orders`,
		}),
	headers: () => ({
		"content-security-policy": buildCsp({
			frameAncestors: [],
			shopper: true,
		}),
		"referrer-policy": "no-referrer",
	}),
	component: TrackingRoute,
});

function TrackingRoute() {
	const page = Route.useLoaderData();
	const { token } = Route.useParams();
	return <OrderTracking page={page} token={token} />;
}
